// 工作台
import Workbench from '../view/Workbench/Workbench'
import Workbench3 from '../view/Workbench/Workbench_3'
import WorkbenchApproval from '../view/Workbench/WorkbenchApproval'
import ApprovalDetail from '../view/Workbench/ApprovalDetail'
import OtherApprovalDetail from '../view/Workbench/OtherApprovalDetail'
import HatchApprovalDetail from '../view/Workbench/HatchApprovalDetail'
import UpdateDetail from '../view/Workbench/UpdateDetail'

export default [
    /* 工作台 */
    {
        path: '/workbench',
        name: 'workbench',
        components: {
            a: Workbench3
        }
    },
    {
        path: '/Workbench_3',
        name: 'workbench-3',
        components: {
            a: Workbench
        }
    },
    {
        path: '/workbench_approval',
        name: 'workbench-approval',
        components: {
            a: WorkbenchApproval
        }
    },
    {
        path: '/approval_detail',
        name: 'approval-detail',
        components: {
            a: ApprovalDetail
        }
    },
    {
        path: '/other_approval_detail',
        name: 'other-approval-detail',
        components: {
            a: OtherApprovalDetail
        }
    },
    {
        path: '/hatch_approval_detail',
        name: 'hatch-approval-detail',
        components: {
            a: HatchApprovalDetail
        }
    },
    {
      path: '/update_detail',
      name: 'update-detail',
      components: {
        a: UpdateDetail
      }
    },
    /* 工作台 */
]



// WEBPACK FOOTER //
// ./src/router/Workbench.js